export default __webpack_public_path__ + "static/media/FM.523d6177.svg";